<template>
    <div class="i-have-examine">
        <examineModel :examineType="type" />
    </div>
</template>

<script type="text/javascript">
    import examineModel from './examine-model.vue' 
    export default {
        data(){
            return {
                type: 3,   // 1：待我审批的；2：我已审批的；3：我发起的；4：抄送给我的；
            }
        },
        components:{
            examineModel
        },
        created(){

        },
        methods:{
           
        }
    }
</script>

<style type="text/css" lang="scss">
     #examine{
        .index-container{

        }
    }
</style>